'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
* Wrapper class for images on HelloSign.
* Deprecated - <img /> elements work just fine now since image sources are resolved via webpack. (CC)
*/

var VALID_IMAGE_PROPS = { 'src': true, 'className': true, 'style': true, 'meta': true };

var Image = _react2['default'].createClass({
    displayName: 'Image',


    propTypes: {
        'src': _react2['default'].PropTypes.any,
        'className': _react2['default'].PropTypes.string,
        'style': _react2['default'].PropTypes.object
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'src': null,
            'className': '',
            'style': {}
        };
    },
    getInitialState: function getInitialState() {
        return {};
    },
    render: function render() {
        var _this = this;

        // Only add valid keys; prevents browser warnings
        var propsKeys = Object.keys(this.props);
        var imageProps = {};
        propsKeys.filter(function (key) {
            if (VALID_IMAGE_PROPS[key] === true) {
                imageProps[key] = _this.props[key];
            }
        });

        return _react2['default'].createElement('img', imageProps);
    }
});

module.exports = Image;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/image.jsx
 ** module id = 808
 ** module chunks = 0 1
 **/